import cx from 'classnames';
import {observer} from 'mobx-react';
import React, {useState} from 'react';

import ExpandPlusIcon from '@udemy/icons/dist/expand-plus.ud-icon';

import {CreateModal} from 'src/components/create-modal/create-modal.react-component';
import {ApiClientStore} from 'src/stores/api-client-store';
import {CreateModalStore} from 'src/stores/create-modal-store';

import styles from '../api-clients.module.less';

export const AddApiClientBox = observer(({apiClientStore}: {apiClientStore: ApiClientStore}) => {
    const [createModalStore] = useState(() => new CreateModalStore(apiClientStore));
    return (
        <>
            <div
                className={cx(styles['client-box'], styles['client-box-add'])}
                role="button"
                onClick={() => createModalStore.open()}
                onKeyPress={() => createModalStore.open()}
                tabIndex={0}
            >
                <ExpandPlusIcon size="large" />
                <p>Create new API client</p>
            </div>
            <CreateModal createModalStore={createModalStore} />
        </>
    );
});
